import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { AnalyticsService } from '../../../../shared/services/analytics.service';

@Component({
  selector: 'app-operator-workspace-section',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, RouterModule],
  templateUrl: './operator-workspace-section.component.html',
  styleUrl: './operator-workspace-section.component.scss'
})
export class OperatorWorkspaceSectionComponent {
  private readonly analytics = inject(AnalyticsService);

  readonly capabilities = [
    { icon: 'domain', label: 'See every organization in one place' },
    { icon: 'flag', label: 'Surface issues across your portfolio' },
    { icon: 'groups', label: 'Shared staff in one operating environment' }
  ];

  onOperatorCta(): void {
    this.analytics.trackCtaClick('pricing-operator-click');
  }
}
